export const JURY_ROLE_ID = 3;
export const PRESIDENT_JURY_ROLE_ID = 4;
